module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('ul', {
    staticClass: "list_ch clearfix"
  }, _vm._l((_vm.choose), function(good) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/detail/' + good.iid
      }
    }, [_c('img', {
      attrs: {
        "src": good.image
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "li_title"
    }, [_vm._v(_vm._s(good.title))]), _vm._v(" "), _c('p', {
      staticClass: "mo_price"
    }, [_vm._v(_vm._s(good.price))]), _vm._v(" "), _c('p', {
      staticClass: "buy"
    }, [_vm._v(_vm._s(good.buyCount) + "人已购买")])])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-92f11646", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-92f11646","hasScoped":false}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/pseek.vue
// module id = 232
// module chunks = 0